export default __webpack_public_path__ + "static/media/bolinhas2.114f7bfb.svg";